const types = ['number', 'integer', 'boolean', 'array', 'object', 'null'];

export default types;
